const today = new Date();

export const SurtyGeneralInsuraceInitialValues = {
  owner_data: {
    public_document_id: '',
    name: '',
    birth_date: '',
    email: '',
    phone: '',
    zip_code: '',
    street: '',
    number: '',
    district: '',
    city: '',
    state: '',
    complement: '',
  },
  rent_insurance_contract_start_date: today,
  rent_insurance_contract_end_date: null,
}